/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-shadow */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, Polyline, Marker } from '@react-google-maps/api';
import polyline from '@mapbox/polyline';
import { generateUniqueId } from '../../Utils/Constants/utils';

const BookingPoolMaps = ({ bookings }) => {
	const [combinedPath, setCombinedPath] = useState([]);
	const [pickUps, setPickUps] = useState([]);
	const [dropOffs, setDropOffs] = useState([]);
	const center = { lat: 35.9375, lng: 14.3754 };

	const mapRef = useRef(null);
	const COLORS = ['#EA4335', '#17a773', '#0000FF', '#FFFF00', '#FF00FF'];
	const createMarkerIcon = (color) => ({
		path: 'M 0 -8 C -2 -20 -10 -22 -10 -30 A 10 10 0 1 1 10 -30 C 10 -22 2 -20 0 -8 z',
		fillColor: color,
		fillOpacity: 1,
		strokeColor: '#ffffff',
		strokeWeight: 1,
		scale: 1.3,
		anchor: new window.google.maps.Point(0, -8),
		labelOrigin: new window.google.maps.Point(0, -30),
	});

	useEffect(() => {
		if (!bookings || bookings.length === 0) return;

		const bookingsWithPolyline = bookings.filter((b) => b?.polyline != null);

		const newPickUps = [];
		const newDropOffs = [];
		const newCombinedPath = [];

		bookingsWithPolyline.forEach((booking) => {
			const decoded = polyline.decode(booking.polyline);
			const path = decoded.map(([lat, lng]) => ({ lat, lng }));

			newPickUps.push(path[0]);
			newDropOffs.push(path[path.length - 1]);
			newCombinedPath.push(...path);
		});

		setPickUps(newPickUps);
		setDropOffs(newDropOffs);
		setCombinedPath(newCombinedPath);
	}, [bookings]);

	useEffect(() => {
		if (combinedPath.length === 0 || !mapRef.current) return;

		const bounds = new window.google.maps.LatLngBounds();
		combinedPath.forEach((point) => bounds.extend(point));

		mapRef.current.fitBounds(bounds);
	}, [combinedPath]);

	const onLoad = (map) => {
		mapRef.current = map;
	};

	return (
		<GoogleMap
			id='circle-example'
			mapContainerStyle={{
				borderRadius: '16px',
				height: '410px',
				width: '99%',
			}}
			zoom={7}
			center={combinedPath.length === 0 ? center : undefined}
			onLoad={onLoad}
			options={{
				disableDefaultUI: true,
				zoomControl: true,
			}}>
			{combinedPath.length > 0 && (
				<>
					<Polyline
						path={combinedPath}
						options={{
							strokeColor: '#2979FF',
							strokeOpacity: 1,
							strokeWeight: 5,
						}}
					/>
					{pickUps.map((pickup, index) => (
						<Marker
							key={generateUniqueId()}
							position={pickup}
							icon={createMarkerIcon(COLORS[index])}
							label={{
								text: 'P',
								color: '#000',
								fontSize: '12px',
								fontWeight: 'bold',
							}}
						/>
					))}

					{dropOffs.map((dropOff, index) => (
						<Marker
							key={generateUniqueId()}
							position={dropOff}
							icon={createMarkerIcon(COLORS[index])}
							label={{
								text: 'D',
								color: '#000',
								fontSize: '12px',
								fontWeight: 'bold',
							}}
						/>
					))}
				</>
			)}
		</GoogleMap>
	);
};

export default BookingPoolMaps;
